import axios from "axios";
import cw from "../../utils/commonwords";
import {
  ADD_GROUP,
  ADD_GROUP_SUCCESS,
  ADD_GROUP_FAILED,
  RESET_GROUP_CREATED,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS,
  FETCH_GROUPS_FAILED,
  RESET_GROUP_UPDATED,
  FETCH_GROUP_PEOPLE,
  FETCH_GROUP_PEOPLE_SUCCESS,
  FETCH_GROUP_PEOPLE_FAILED,
  ADD_PERSON_TO_GROUP_SUCCESS,
  ADD_PERSON_TO_GROUP,
  RESET_PERSON_ADDED_TO_GROUP,
  ADD_PERSON_TO_GROUP_FAILED,
  REMOVE_PERSON_FROM_GROUP,
  REMOVE_PERSON_FROM_GROUP_SUCCESS,
  REMOVE_PERSON_FROM_GROUP_FAILED,
  RESET_PERSON_REMOVED_FROM_GROUP,
  RENAME_GROUP,
} from "./types";
import bugsnag from "@bugsnag/js";
import { notification } from "antd";
import { getCookie } from "../../utils/helpers";
import { API_URL } from "../../config/environment";
import { push, replace } from "connected-react-router";
import { signOutUser } from "../auth/actions";
import { RESET_PEOPLE_PAGE } from "../people/types";
const bugsnagClient = bugsnag("ab84c0b67d6464d40ea9bc8050d778e7");
export const addGroup = (data, userId, intl, siteLanguage) => {
  return (dispatch) => {
    dispatch({ type: ADD_GROUP });
    axios({
      method: "POST",
      url: `${API_URL}/groups`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
      data,
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch({
            type: ADD_GROUP_SUCCESS,
            payload: response.data,
          });
          dispatch(fetchGroups(userId, intl, siteLanguage));
          notification.success({
            message: intl.formatMessage(cw.Success),
            description: intl.formatMessage(cw["GroupCreateSuccess"], {
              group: data.name,
            }),
          });
          setTimeout(() => {
            dispatch({
              type: RESET_GROUP_CREATED,
            });
          }, 100);
          dispatch(push(`/en/groups/${response.data.data.uuid}`));
        } else if (response.data.status === 403) {
          notification.warn({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw["GroupExists"], {
              group: data.name,
            }),
          });
          dispatch({ type: ADD_GROUP_FAILED });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          notification.error({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw["GroupCreateFailed"]),
          });
          dispatch({ type: ADD_GROUP_FAILED });
        }
      })
      .catch((err) => {
        dispatch({ type: ADD_GROUP_FAILED });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw["GroupCreateFailed"]),
        });
        bugsnagClient.notify(err);
      });
  };
};

export const addPeopleToGroup = (
  groupId,
  people,
  userId,
  intl,
  siteLanguage,
  onOK
) => {
  return (dispatch) => {
    dispatch({ type: ADD_PERSON_TO_GROUP });
    const personId = [].concat(people);
    axios({
      method: "PUT",
      url: `${API_URL}/groups/${groupId}/persons`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
      data: {
        personId,
      },
      // data
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch({
            type: ADD_PERSON_TO_GROUP_SUCCESS,
            payload: response.data,
          });
          dispatch(fetchGroups(userId, intl, siteLanguage));
          notification.success({
            message: intl.formatMessage(cw.Success),
            description: `${
              personId.length === 1
                ? intl.formatMessage(cw["PersonAddSuccess"])
                : intl.formatMessage(cw["PeopleAddSuccess"])
            }`,
          });
          setTimeout(() => {
            onOK && onOK();
            dispatch({
              type: RESET_PERSON_ADDED_TO_GROUP,
            });
          }, 100);

          // dispatch(push(`/en/groups/${groupId}`));
        } else if (response.data.status === 403) {
          notification.warn({
            message: intl.formatMessage(cw.Failed),
            description: `${response.data.reason}`,
          });
          dispatch({ type: ADD_PERSON_TO_GROUP_FAILED });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          notification.error({
            message: intl.formatMessage(cw.Failed),
            description: `${
              personId.length === 1
                ? intl.formatMessage(cw["PersonAddFailed"])
                : intl.formatMessage(cw["PeopleAddFailed"])
            }`,
          });
          dispatch({ type: ADD_PERSON_TO_GROUP_FAILED });
        }
      })
      .catch((err) => {
        dispatch({ type: ADD_PERSON_TO_GROUP_FAILED });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: `${
            personId.length === 1
              ? intl.formatMessage(cw["PersonAddFailed"])
              : intl.formatMessage(cw["PeopleAddFailed"])
          }`,
        });
        bugsnagClient.notify(err);
      });
  };
};

export const updateGroup = (uuid, data, userId, intl, siteLanguage) => {
  return (dispatch) => {
    dispatch({ type: ADD_GROUP });
    axios({
      method: "PUT",
      url: `${API_URL}/groups/${uuid}`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
      data,
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch({
            type: ADD_GROUP_SUCCESS,
            payload: response.data,
          });
          dispatch(fetchGroups(userId, intl, siteLanguage));

          dispatch({
            type: RENAME_GROUP,
            id: uuid,
            name: data.name,
          });
          notification.success({
            message: intl.formatMessage(cw.Success),
            description: intl.formatMessage(cw["GroupEditSuccess"]),
          });
          setTimeout(() => {
            dispatch({
              type: RESET_GROUP_UPDATED,
            });
          }, 100);
        } else if (response.data.status === 403) {
          notification.warn({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw["GroupExists"]),
          });
          dispatch({ type: ADD_GROUP_FAILED });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          notification.error({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw["GroupEditFailed"]),
          });
          dispatch({ type: ADD_GROUP_FAILED });
        }
      })
      .catch((err) => {
        dispatch({ type: ADD_GROUP_FAILED });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw["GroupEditFailed"]),
        });
        bugsnagClient.notify(err);
      });
  };
};
export const deleteGroup = (uuid, userId, intl, siteLanguage, match) => {
  return (dispatch) => {
    dispatch({ type: "DELETE_GROUP" });
    axios({
      method: "DELETE",
      url: `${API_URL}/groups/${uuid}`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(fetchGroups(userId, intl, siteLanguage));
          dispatch({
            type: "DELETE_GROUP_SUCCESS",
            payload: response.data,
          });
          notification.success({
            message: intl.formatMessage(cw.Success),
            description: intl.formatMessage(cw["GroupDeleteSuccess"]),
          });
          if (window.location.href.endsWith(uuid)) {
            dispatch(replace(`/${siteLanguage}/everyone`));
          } else {
          }
        } else if (response.data.status === 403) {
          notification.warn({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw["GroupExistsNot"]),
          });
          dispatch({ type: "DELETE_GROUP_FAILED" });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          notification.error({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw["GroupDeleteFailed"]),
          });
          dispatch({ type: "DELETE_GROUP_FAILED" });
        }
      })
      .catch((err) => {
        dispatch({ type: "DELETE_GROUP_FAILED" });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw["GroupDeleteFailed"]),
        });
        bugsnagClient.notify(err);
      });
  };
};
export const fetchGroups = (userId, intl, siteLanguage) => {
  return (dispatch) => {
    dispatch({ type: FETCH_GROUPS });
    axios({
      method: "GET",
      url: `${API_URL}/groups?page=1&limit=1000&sortBy=name&direction=ASC`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch({
            type: FETCH_GROUPS_SUCCESS,
            payload: response.data,
          });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else if (response.data.status === 404) {
          // notification.info({
          //   message: 'No groups',
          //   description: `You have no groups`
          // });
          dispatch({
            type: FETCH_GROUPS_FAILED,
            groupsFound: false,
          });
        } else {
          // notification.error({
          //   message: intl.formatMessage(cw.Failed),
          //   description: `Failed to fetch groups`
          // });
          dispatch({ type: FETCH_GROUPS_FAILED });
        }
      })
      .catch((err) => {
        dispatch({ type: FETCH_GROUPS_FAILED });
        // notification.error({
        //   message: intl.formatMessage(cw.Failed),
        //   description: `Failed to fetch groups`
        // });
        bugsnagClient.notify(err);
      });
  };
};
export const fetchGroupPeople = (
  groupId,
  userId,
  intl,
  siteLanguage,
  limit,
  page,
  query
) => {
  return (dispatch) => {
    dispatch({ type: FETCH_GROUP_PEOPLE, query: query });
    axios({
      method: "GET",
      url: `${API_URL}/groups/${groupId}/persons?sortBy=First Name&limit=${
        limit || 250
      }&page=${page || 1}${query ? `&query=${query}` : ""}`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch({
            type: FETCH_GROUP_PEOPLE_SUCCESS,
            payload: response.data,
            fetchedGroupId: groupId,
            groupPeoplePage: page || 1,
            query: query,
          });
          dispatch({
            type: RESET_PEOPLE_PAGE,
          });
        } else if (response.data.status === 404) {
          dispatch({
            type: FETCH_GROUP_PEOPLE_SUCCESS,
            payload: response.data,
            fetchedGroupId: groupId,
            query: query,
          });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          dispatch({
            type: FETCH_GROUP_PEOPLE_FAILED,
            fetchedGroupId: groupId,
          });
        }
      })
      .catch((err) => {
        // console.log(err)
        dispatch({ type: FETCH_GROUP_PEOPLE_FAILED, fetchedGroupId: groupId });
        // notification.error({
        //   message: intl.formatMessage(cw.Failed),
        //   description: `Failed to fetch people`
        // });
        bugsnagClient.notify(err);
      });
  };
};
export const removePersonFromGroup = (
  personId,
  groupId,
  userId,
  intl,
  siteLanguage
) => {
  return (dispatch) => {
    dispatch({ type: REMOVE_PERSON_FROM_GROUP });
    axios({
      method: "DELETE",
      url: `${API_URL}/persons/${personId}/groups/${groupId}`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`,
      },
    })
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(fetchGroupPeople(groupId, userId, intl, siteLanguage));
          dispatch(fetchGroups(userId, intl, siteLanguage));

          dispatch({
            type: REMOVE_PERSON_FROM_GROUP_SUCCESS,
          });
          setTimeout(() => {
            dispatch({
              type: RESET_PERSON_REMOVED_FROM_GROUP,
            });
          }, 100);
          notification.success({
            message: intl.formatMessage(cw.Success),
            description: intl.formatMessage(cw["PersonRemoveSuccess"]),
          });
        } else if (
          response.data.status === 498 ||
          response.data.status === 401
        ) {
          dispatch(signOutUser(userId, intl, siteLanguage));
        } else {
          notification.error({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw.FailedRemovePerson),
          });
          dispatch({
            type: REMOVE_PERSON_FROM_GROUP_FAILED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: REMOVE_PERSON_FROM_GROUP_FAILED,
        });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.FailedRemovePerson),
        });
        bugsnagClient.notify(err);
      });
  };
};
